export default "__VITE_ASSET__ce8e3ee7__"